// src/components/layout/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-wrapper mt-auto py-3 bg-light"> {/* Use bg-light or another subtle background */}
            <Container fluid className="text-center footer-powered-by">
                 © {currentYear} LMS. {t('poweredBy')} <a href="https://peocty.com/" target="_blank" rel="noopener noreferrer" className="fw-semibold">PEOCIT Technologies</a>. {/* Add link */}
            </Container>
        </footer>
    );
};

export default Footer;